import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'
function Star({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 17 18' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.49773 15.3706L12.5779 17.6088C13.3726 18.0451 14.3013 17.3409 14.1492 16.4162L13.3704 11.6719
        L16.6718 8.31468C17.3143 7.6603 16.9601 6.51987 16.0723 6.38473L11.5108 5.69241L9.4718 1.37492C9.07445
        0.533231 7.92782 0.533231 7.53047 1.37492L5.4915 5.69241L0.927673 6.3871C0.0398824 6.52224 -0.314325
        7.66267 0.328244 8.31705L3.62964 11.6743L2.85084 16.4186C2.69871 17.3433 3.62737 18.0474 4.42207
        17.6112L8.50227 15.373H8.49773V15.3706Z'
        fill={fill}
        stroke={color}
        strokeWidth='0.8'
        strokeLinecap='miter'
        strokeLinejoin='miter'
      />
    </IconBase>
  )
}

Star.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Star
